// Lesson 1 — Tiles & families. A guided tour: mostly `info` steps that highlight
// one tile from each family in the learner's opening hand, then a single trivial
// discard so the learner exercises the discard mechanic once. Routed through the
// real engine/LessonController like every other lesson (see the plan's T12
// decision) even though it teaches no strategy.

import { createDealBuilder, fillerBot } from './deckBuilder.js';
import type { LessonScript } from '../types.js';

const b = createDealBuilder();

const man5 = b.suit('man', 5);
const pin5 = b.suit('pin', 5);
const sou5 = b.suit('sou', 5);
const sou7 = b.suit('sou', 7);
const east = b.honor('east');
const north = b.honor('north');
const red = b.honor('red');

const human = [
  man5,
  b.suit('man', 2),
  b.suit('man', 3),
  pin5,
  b.suit('pin', 2),
  b.suit('pin', 3),
  sou5,
  b.suit('sou', 2),
  b.suit('sou', 3),
  sou7,
  east,
  red,
  north,
];

const seat1 = fillerBot(b, 'south', [['man', 1], ['man', 4], ['pin', 4], ['pin', 7]]);
const seat2 = fillerBot(b, 'west', [['sou', 4], ['sou', 6], ['pin', 1], ['man', 6]]);
const seat3 = fillerBot(b, 'green', [['man', 7], ['pin', 3], ['sou', 1], ['sou', 7]]);

const wall = [
  b.suit('pin', 7),
  b.suit('man', 5),
  b.suit('pin', 6),
  b.suit('sou', 5),
  b.suit('man', 2),
  b.suit('pin', 2),
];

export const lesson1Tiles: LessonScript = {
  id: 'lesson-1-tiles',
  titleKey: 'lesson.script.tiles.title',
  deal: { hands: [human, seat1, seat2, seat3], wall },
  steps: [
    { instructionKey: 'lesson.script.tiles.intro', expectedAction: { kind: 'info' }, autoAdvance: false },
    {
      instructionKey: 'lesson.script.tiles.suits',
      expectedAction: { kind: 'info' },
      highlightTileIds: [man5.id, pin5.id, sou5.id],
      autoAdvance: false,
    },
    {
      instructionKey: 'lesson.script.tiles.winds',
      expectedAction: { kind: 'info' },
      highlightTileIds: [east.id, north.id],
      autoAdvance: false,
    },
    {
      instructionKey: 'lesson.script.tiles.dragons',
      expectedAction: { kind: 'info' },
      highlightTileIds: [red.id],
      autoAdvance: false,
    },
    {
      instructionKey: 'lesson.script.tiles.tryDiscard',
      expectedAction: { kind: 'discard', tileId: sou7.id },
      highlightTileIds: [sou7.id],
      autoAdvance: true,
    },
    { instructionKey: 'lesson.script.tiles.done', expectedAction: { kind: 'info' }, autoAdvance: false },
  ],
};
